export const routes = {
  home: "/",
  login: "/login",
  register: "/register",
  profile: "/profile",
  product: "/san-pham",
  order: "/order",
  404: "/not-found",
  500: "/500",
  checkout: "/checkout",
  search: "/san-pham",
  cart: "/gio-hang",
  game: {
    index: "/game",
    rule: "/game/rule",
    guess: "/game/guess-word",
    spin: "/game/spin-wheel",
  },
};

export const routespProfile = {
  info: "/profile/my-info",
  address: "/profile/address",
  historyOrder: "/profile/history-order",
  statusOrder: "/profile/status-order",
  referral: "/profile/hoat-dong",
  successs: "/checkout/success",
};
